import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Department } from './department';
import { BsModalRef, ModalOptions, BsModalService } from 'ngx-bootstrap';
import { DepartmentService } from './department.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'ng2-bootstrap-modal';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { LocalService } from '../../local.service';
declare var $: any;

@Component({
  selector: 'app-department',
  templateUrl: './department.component.html',
  styleUrls: ['./department.component.css']
})
export class DepartmentComponent implements OnInit {
  sendMenuId: number;
  sendPageName: string = 'Department';
  //action rights
  _menuId: any;
  _actionRights: any;
  submitShow: boolean;
  readOnly: boolean; add: boolean; edit: boolean; delete: boolean;
     departmentForm: FormGroup;
  departments: Department[]=[];
  departmentsactive: Department[] = [];
  department: Department;
  deleteResult: boolean
  postresult: boolean
  putDResult: boolean
  departmentModalRef: BsModalRef;
  operation: string;
  userid: number;
  departmentid: number;
  submitted = false;
  active: number;
  unamePattern: string;
  confmsg: string;
  p: number = 1; searchText: string;
  itemsPerPage: number = 10;
  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered',
    ignoreBackdropClick: true
  }
  showall: boolean = true;
  showallstatus: boolean = false;
  key: string = 'department'; //set default
  reverse: boolean = false;

  constructor(
    private departmentservice: DepartmentService,
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService, private dialogService: DialogService,
    private localService: LocalService) {    
    //code to get relavent menu id
     if (this.router.getCurrentNavigation().extras.state != undefined) {
     // console.log(this.router.getCurrentNavigation().extras.state);
      localStorage.setItem('Department_menuid', this.router.getCurrentNavigation().extras.state.menuid);
      localStorage.setItem('Department_action', this.router.getCurrentNavigation().extras.state.action);
      this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
      this.sendMenuId = this._menuId;
      this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    }
    else {
      if (this._menuId == undefined)
        this._menuId = localStorage.getItem('Department_menuid');
      this.sendMenuId = this._menuId;
      if (this._actionRights == undefined)
        this._actionRights = localStorage.getItem('Department_action');
    } 
  }

  ngOnInit() {
    this.checkIsMenuMapped();
    this.departmentForm = this.formBuilder.group({
      departmentid: [''],
      department: ['', [Validators.required]],
      active: ['']
    });
    this.searchText = '';
    this.getAll();

    //for action rights
    this.readOnly = false;
    this.add = false;
    this.edit = false;
    this.delete = false;
    this.submitShow = false;
    this.getActionRightsList();
  }

  getactiveinactive(showallp) {
    this.departmentsactive = [];
    this.showall = showallp;
    this.showallstatus = showallp;
    if (this.showall == true) {
      this.showall = false;
      this.departments.forEach(data => {
        if (data.active == 1) {
          this.departmentsactive.push(data);
        }
      });
      this.departments = [];
      this.departments = this.departmentsactive;
    }
    else {
      this.showall = true;
      this.departments = [];
      this.getAll();
    }
  }
  
  checkIsMenuMapped()
  {
    const arrays = this.localService.getJsonValue("menulist");
    const notauthorized = this.localService.getJsonValue("notauthorizeddepartment");
    let data = arrays.find(ob => ob['name'] === 'Department');
    if((data == undefined || data =='') && (notauthorized!=="true"))
    {
      this.localService.setJsonValue("notauthorizeddepartment","true");
      this.toastr.error('You are not authorized to access this page.');
      this.router.navigate(["home"]);
    }
    if(notauthorized=="true"){
      this.localService.setJsonValue("notauthorizeddepartment",null);
      this.router.navigate(["home"]);      
    }
  }

  //assigning value from menu rights button
  getActionRightsList() {
    var btnToEnable = JSON.parse(this._actionRights);
    if (btnToEnable.length > 0) {
      btnToEnable.forEach(d => {
        if (d != undefined) {
          if (d == 1)
            this.readOnly = true;
          else if (d == 2) {
            this.readOnly = true;
            this.add = true;
            this.submitShow = true;
          }
          else if (d == 3) {
            this.readOnly = true;
            this.edit = true;
            // this.submitShow = true;
          }
          else if (d == 4) {
            this.readOnly = true;
            this.delete = true;
          }
        }
      });
    }
  }

  clearForm() {
    //for action rights
    if (this.add == true)
      this.submitShow = true;
    else
      this.submitShow = false;
    this.departmentModalRef.hide();
  }

  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  getAll() {
    this.departments = [];
    this.departmentsactive = [];
    this.departmentservice.Get().subscribe(res => {
      this.departments = res;
      if (this.showallstatus == true) {
        this.departments.forEach(data => {
          if (data.active == 1) {
            this.departmentsactive.push(data);
          }
        });
        this.departments = [];
        this.departments = this.departmentsactive;
      }
    }, error => { this.toastr.error('Error while getting data'); });

  }

  get g() { return this.departmentForm.controls; }

  Post(department: Department) {
    
    this.submitted = true;
    // stop here if form is invalid
    //if (this.departmentForm.invalid) {
    //  console.log(this.g);
    //  console.log(this.departmentForm.errors);
    //}

    if ((department.department.trim() == undefined) || (department.department.trim() == '')) {
      this.toastr.error('Department should not be empty');
      return;
    }

    var msg = null;

    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    department.department = department.department.trim();
    if (this.operation == 'add') {

      department.createdby = this.userid;
      msg = "Record Added Successfully";
      this.departmentservice.Post(department).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            if (res.body != 0) {
              this.departmentModalRef.hide();
              this.getAll();
              this.toastr.success('Data added successfully');
              this.clearForm();
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }
    else if (this.operation = 'update') {
      this.submitShow = true;
      department.modifiedby = this.userid;
      msg = "Record updated successfully";
      this.departmentservice.Put(department).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            ;
            if (res.body != 0) {
              this.departmentModalRef.hide();
              this.getAll();
              this.toastr.success('Data updated successfully');
              this.clearForm();
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }

    //console.log(this.departmentForm.value);


  }

  ChangeActive(e) {
    if (e.currentTarget.checked) {
      this.departmentForm.value.active = 1;
    } else {
      this.departmentForm.value.active = 0
    }
  }

  OpenConfirmTemplate(department, template: TemplateRef<any>) {
    if (department.active == 0) {
      this.confmsg = "activate";
    }
    else
      this.confmsg = "deactivate";
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to ' + this.confmsg + ' this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.department = department;

          this.Delete();

        }
      
      });

  }
  
  Delete() {
    var msg;
    if (this.department.active == 0) {
      this.department.active = 1
      msg = "Record activated successfully"
    }
    else {
      this.department.active = 0;
      msg = "Record deactivated successfully"
    }
    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    this.department.modifiedby = this.userid;
    this.departmentservice.Delete(this.department).subscribe(res => {
      this.toastr.success(msg);
      this.getAll();
    },
      error => { this.deleteResult = false })

  }
   
  hidePopup() {
    this.departmentModalRef.hide();
  }

  openDepartmentModal(template: TemplateRef<any>, type, department?: Department) {

    this.operation = type
   
    if (type == 'update') {
      this.departmentForm.controls['departmentid'].setValue(department.departmentid);
      this.departmentForm.controls['department'].setValue(department.department);
      this.departmentForm.controls['active'].setValue(department.active);
      this.department = department;
    }
    if (type == 'add') {
      this.departmentForm.controls['departmentid'].setValue(0);
      this.departmentForm.controls['department'].setValue('');
      this.departmentForm.controls['active'].setValue(1);
    }
    this.departmentModalRef = this.modalService.show(template, this.config);
    
    const aa = document.getElementsByClassName('modal-content');
    aa[0].classList.remove("modal-content");

  }
   
}
